// @ts-nocheck
import * as React from 'react';
import TextLink from 'crehana-ui/Buttons/TextLink';

const Header: React.FC<{
  title: string;
  subtitle: string;
  logoUrl: string;
  externalLink?: {
    label: string;
    url: string;
  };
}> = ({ title, subtitle, logoUrl, externalLink }) => {
  return (
    <div className="flex flex-col items-center text-center py-48 md:py-80">
      <div className="mb-24 sm:mb-32">
        <img
          className="block max-w-full h-auto"
          src={logoUrl}
          alt="mastercard"
        />
      </div>
      <p className="font-subtitle2 text-white mb-16">{title}</p>
      <p
        className="font-body2 text-white text-center mx-auto"
        style={{ maxWidth: 736 }}
      >
        {subtitle}
      </p>
      {externalLink && (
        <div className="text-center mt-24">
          <TextLink label={externalLink.label} href={externalLink.url} />
        </div>
      )}
    </div>
  );
};

export default Header;
